import type { ReportBlock } from '@/lib/types/report'
import { tableStyles } from '../primitives/tableStyles'

export function GeneralTable({ block }: { block: ReportBlock }) {
  const fields = (block.data.fields as { label: string; value: string; unit?: string }[]) ?? []
  return (
    <table className={tableStyles.table}>
      <tbody>
        {fields.map((f) => (
          <tr key={f.label} className={tableStyles.row}>
            <th scope="row" className="w-56 py-1.5 pr-4 text-left font-medium text-muted-foreground">
              {f.label}
            </th>
            <td className={tableStyles.cell}>{f.value}{f.unit ? ` ${f.unit}` : ''}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
